import { useMutation, useQueryClient } from '@tanstack/react-query';
import { WalletConnector } from '@/modules/Wallet/interface/walet';
import { api } from '@/libs/axios/apiClient';
import { apiConfig } from '@/config/api';
const updateInstitution = async (id: WalletConnector['id']) => {
  await api.put(apiConfig.routes.wallet.pluggy.item(id));
};
export const useUpdateInstitution = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateInstitution,
    onSettled: () => {
      [['wallet', 'summary'], ['wallet', 'institutions'], ['wallet', 'connectors'], ['consolidator', 'wallet', 'optimizer', 'status'], ['wallet', 'investments'], ['wallet', 'investments', 'categories'], ['wallet', 'investments', 'institutions'], ['wallet', 'optimizer', 'status']].forEach(key => {
        queryClient.invalidateQueries({
          queryKey: key
        });
      });
    }
  });
};